var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeakLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 39,
    viewBox: "0 0 182 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.028 8.19489H127.811L114.683 38.3601H123.676L131.842 18.0489L135.253 26.5454H130.912L128.327 33.0309H137.734L139.956 38.3601H149.104L136.028 8.19489Z",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4431 8.19489H57.1091V38.4607H65.74V15.2334H69.7712C72.8722 15.2334 74.7327 16.6412 74.7327 19.2052V19.3057C74.7327 21.6687 72.8722 23.2272 69.8229 23.2272H69.7712L66.4119 29.8133H69.978C77.7303 29.8133 83.3637 26.0427 83.3637 18.9035V18.803C83.4154 12.1164 78.2988 8.19489 70.4431 8.19489Z",
    fill: "#323232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8192 31.2713V26.4951H107.861L110.704 19.9091H95.8192V15.334H109.153L112.254 8.19489H87.3433V38.3601H109.36L112.461 31.2713H95.8192Z",
    fill: "#323232"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181.302 8.19489H170.965L160.939 23.3278L165.487 30.6177L170.965 38.4104H181.302L170.655 23.3278L181.302 8.19489Z",
    fill: "#323232"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.887 8.19489H152.256V38.4104H160.887V23.3278V8.19489Z",
    fill: "#323232"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3521 31.6735L18.0372 21.4173L19.5876 24.2327V24.1825L21.1898 0L0 38.3601H18.6573L19.1225 31.6735H12.3521Z",
    fill: "#C63D4D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1898 0L19.5876 24.1825L23.0504 17.9986L30.596 31.6735H19.1225L18.6573 38.3601H42.3796L21.1898 0Z",
    fill: "#96324B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeakLogoDark);
export default __webpack_public_path__ + "static/media/peak-logo-dark.b36064993b4ee4c7f6eede2a1f37671d.svg";
export { ForwardRef as ReactComponent };